<template>
  <div>
    <title-bar-back :title="'礼品卡详情'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <div class="top_bor">
      <img :src="queryCardVoucherUserById.detailImg" alt="" class="top_img" />
      <div class="font12 font_weight400 colof line_height_17 top_det">
        {{ queryCardVoucherUserById.status | status }}
      </div>
    </div>
    <div class="mar text_left">
      <div class="mr_con border_top1px">
        <div
          v-if="true"
          class="mar_item font12 font_weight500 colo087 line_height_17"
        >
          <span class="item_left">领取时间：</span>
          <span>{{
            queryCardVoucherUserById.gmtCreate
              | dateFormatterJava("YYYY-MM-DD HH:mm:ss")
          }}</span>
        </div>
        <!-- <div
          v-if="true"
          class="mar_item font12 font_weight500 colo087 line_height_17"
        >
          <span class="item_left">兑换时间：</span>
          <span>2020-07-08 12:00</span>
        </div> -->
        <!-- <div
          v-if="true"
          class="mar_item font12 font_weight500 colo087 line_height_17"
        >
          <span class="item_left">被领取时间：</span>
          <span>2020-07-08 12:00</span>
        </div> -->
        <!-- <div
          v-if="true"
          class="mar_item font12 font_weight500 colo087 line_height_17"
        >
          <span class="item_left">转赠人：</span>
          <span>11111</span>
        </div>
        <div
          v-if="true"
          class="mar_item font12 font_weight500 colo087 line_height_17"
        >
          <span class="item_left">领取人：</span>
          <span>11111</span>
        </div> -->
        <div
          v-if="true"
          class="mar_item font12 font_weight500 colo087 line_height_17"
        >
          <span class="item_left">订单编号：</span>
          <span>{{ queryCardVoucherUserById.buyOrderSn }}</span>
        </div>
        <!-- <div class="mar_item font12 font_weight500 colo087 line_height_17">
          <span class="item_left">购卡订单编号：</span>
          <span>202010101234567890</span>
        </div>
        <div class="mar_item font12 font_weight500 colo087 line_height_17">
          <span class="item_left">领取订单编号：</span>
          <span>202010101234567890</span>
        </div> -->
        <div class="mar_item1 font12 font_weight500 colo087 line_height_17">
          <div class="item_left">卡片商品：</div>
          <div>
            <div
              v-for="(item, index) in queryCardVoucherUserById.skus"
              :key="index"
              class="sku_list"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <!-- <div class="mar_item font12 font_weight500 colo087 line_height_17">
          <span class="item_left">规格：</span>
          <span>周卡/2L</span>
        </div> -->
      </div>
    </div>

    <!-- <div class="note clearfix text_left" @click="goNote">
      <span>标签与备注</span>
      <div class="note_add right">
        <span class="note_font">{{ "1111" || "添加" }}</span>
        <img
          src="@/assets/common/icon_back_b87_24@2x.png"
          alt=""
          class="go_right"
        />
      </div>
    </div> -->
  </div>
</template>

<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
export default {
  name: "CardDetail",
  components: {
    TitleBarBack
  },
  filters: {
    sourceFilter(id) {
      switch (id) {
        case 1:
          return "用户赠送";
        case 2:
          return "系统赠送";
        case 3:
          return "店主赠送";
        case 4:
          return "商家赠送";
        case 5:
          return "买赠";
      }
    },
    status(status) {
      switch (status) {
        case 0:
          return "卡片已领取";
        case 1:
          return "卡片已被领取";
        case 2:
          return "卡片已兑换";
        case 3:
          return "卡片已失效";
      }
    }
  },
  data() {
    return {
      barIndex: 0
    };
  },
  computed: {
    queryCardVoucherUserById() {
      return this.$store.getters.queryCardVoucherUserById;
    }
  },
  created() {
    this.getData();
  },
  methods: {
    // queryCardVoucherUserById
    getData() {
      const params = { id: this.$route.query.id };
      this.$store
        .dispatch("mine/queryCardVoucherUserById", { params })
        .then(() => {})
        .catch(() => {});
    },
    back() {
      this.$router.back();
    },
    // /mine/cardnote
    goNote() {
      this.$router.push("/mine/cardnote");
    }
  }
};
</script>

<style scoped>
.title_right {
  width: 36px;
}
.top_bor {
  padding: 56px 52px;
  background: #fff;
  font-size: 0;
  position: relative;
}
.top_img {
  display: block;
  width: 100%;
}
.top_det {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.7);
  border-radius: 18px;
  padding: 10px 23px;
}
.mar {
  background: #fff;
}
.mr_con {
  padding: 12px 0 0;
  margin: 0 12px;
}
.mar_item {
  padding-bottom: 12px;
}
.mar_item1 {
  display: flex;
  justify-content: flex-start;
}
.item_left {
  display: inline-block;
  width: 86px;
}
.sku_list {
  padding-bottom: 12px;
}
.note {
  background: #fff;
  margin-top: 12px;
  padding: 0 12px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  line-height: 48px;
}
.note_add {
  color: rgba(153, 153, 153, 1);
}
.note_font {
  vertical-align: middle;
}
.go_right {
  width: 26px;
  vertical-align: middle;
}
</style>
